import {
  either, is, isEmpty, isNil, map, pipe, reject, when,
} from 'ramda';

const removeNullOrEmpty = object => pipe(
  map(when(is(Object), removeNullOrEmpty)),
  reject(either(isNil, isEmpty)),
)(object);

export default removeNullOrEmpty;
